"use client";

import { c as _c } from "react/compiler-runtime";
import { sanitizeStoredAmounts } from "@/hooks/memesQuickVote.helpers";
import { readStoredNumberArray, useStoredNumberArray, writeStoredNumberArray } from "@/hooks/memesQuickVote.storageStore";
import { useCallback } from "react";
const AMOUNTS_STORAGE_PREFIX = "memesQuickVoteAmounts";
type UseMemesQuickVoteStorageOptions = {
  readonly contextProfile: string | null | undefined;
  readonly memesWaveId: string | null | undefined;
};
type UseMemesQuickVoteStorageResult = {
  readonly recentAmountsByRecency: number[];
  readonly setAndPersistRecentAmounts: (updater: (current: number[]) => number[]) => void;
};
const getStorageKey = (prefix: string, memesWaveId: string | null | undefined, contextProfile: string | null | undefined): string | null => {
  if (!memesWaveId || !contextProfile) {
    return null;
  }
  return `${prefix}:${memesWaveId}:${contextProfile}`;
};
const areNumberArraysEqual = (left: readonly number[], right: readonly number[]): boolean => left.length === right.length && left.every((value, index) => value === right[index]);
export const useMemesQuickVoteStorage = t0 => {
  const $ = _c(8);
  const {
    contextProfile,
    memesWaveId
  } = t0;
  let t1;
  if ($[0] !== contextProfile || $[1] !== memesWaveId) {
    t1 = getStorageKey(AMOUNTS_STORAGE_PREFIX, memesWaveId, contextProfile);
    $[0] = contextProfile;
    $[1] = memesWaveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const amountsStorageKey = t1;
  const recentAmountsByRecency = useStoredNumberArray(amountsStorageKey, sanitizeStoredAmounts);
  let t2;
  if ($[3] !== amountsStorageKey) {
    t2 = updater => {
      const current = readStoredNumberArray(amountsStorageKey, sanitizeStoredAmounts);
      const next = sanitizeStoredAmounts(updater([...current]));
      if (areNumberArraysEqual(current, next)) {
        return;
      }
      writeStoredNumberArray(amountsStorageKey, next);
    };
    $[3] = amountsStorageKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setAndPersistRecentAmounts = t2;
  let t3;
  if ($[5] !== recentAmountsByRecency || $[6] !== setAndPersistRecentAmounts) {
    t3 = {
      recentAmountsByRecency,
      setAndPersistRecentAmounts
    };
    $[5] = recentAmountsByRecency;
    $[6] = setAndPersistRecentAmounts;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};